// extracted by mini-css-extract-plugin
export default {"goesOnSaleContainer":"qcNw4t","total":"gNyD7g"};